var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPort({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734589137652,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 45479,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M883.84 940.8H144.64c-42.88 0-80.64-37.76-80.64-80.64V415.36c0-42.88 37.76-80.64 80.64-80.64h21.12v-48c0-48 37.76-85.76 85.76-85.76h69.76v-42.88c0-42.88 32-74.88 74.88-74.88h230.4c42.88 0 74.88 32 74.88 74.88v42.88h69.76c48 0 85.76 37.76 85.76 85.76v48h21.12c42.88 0 80.64 37.76 80.64 80.64v444.8c5.12 42.88-32 80.64-74.88 80.64zM144.64 394.24c-10.88 0-21.12 10.88-21.12 21.12v444.8c0 10.88 10.88 21.12 21.12 21.12h739.2c10.88 0 21.12-10.88 21.12-21.12V415.36c0-10.88-10.88-21.12-21.12-21.12h-48c-16 0-26.88-10.88-26.88-26.88V286.72c0-16-10.88-32-32-32h-101.76c-16 0-26.88-10.88-26.88-26.88V158.08c0-10.88-10.88-21.12-21.12-21.12H401.28c-10.88 5.12-21.12 10.88-21.12 21.12v69.76c0 16-10.88 26.88-26.88 26.88H251.52c-16 5.12-26.88 16-26.88 32v74.88c0 16-10.88 26.88-26.88 26.88-5.12 5.76-53.12 5.76-53.12 5.76z m0 0",
    fill: "currentColor",
    "p-id": 45480
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M755.2 517.12h85.76v273.28H755.2V517.12z m-139.52 0h85.76v273.28H615.68V517.12z m-138.88 0h85.76v273.28H476.8V517.12z m-139.52 0h85.76v273.28H337.28V517.12z m-139.52 0h85.76v273.28H197.76V517.12z m0 0",
    fill: "currentColor",
    "p-id": 45481
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPort);
export default __webpack_public_path__ + "static/media/port.39cac38863ff4d337b79a6507d9a5892.svg";
export { ForwardRef as ReactComponent };